export default {
  async get(url, options = {}) {
    const res = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      ...options,
    })

    const responseType = res.headers.get('content-type') || ''
    const data = responseType.includes('application/json')
      ? await res.json()
      : await res.text()
    const { ok, status } = res
    return { data, ok, status }
  },

  async post(url, payload, options = {}) {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      ...options,
    })

    const responseType = res.headers.get('content-type') || ''
    const data = responseType.includes('application/json')
      ? await res.json()
      : await res.text()
    const { ok, status } = res
    return { data, ok, status }
  },
}
